import { useState } from 'react';

import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Button, List } from 'antd';

import getTimeInSeconds from '@/lib/helpers/getTimeInSeconds';
import prepareTimestampStr from '@/lib/helpers/prepareTimestampStr';

import ExtractLocaleItems from '../ExtractLocaleItems';

type TProps = {
	item: {
		Emoji: string;
		Sentence: string;
		Extract: string;
		Timestamp: string;
	};
	videoSeekToTime: (seconds: number) => void;
	videoDuration: number;
};

export default function InsightCollapsableItem({
	item,
	videoSeekToTime,
	videoDuration,
}: TProps) {
	const [collapsed, setCollpased] = useState(true);
	const seconds = getTimeInSeconds(item?.Timestamp);
	const preparedTimestampStr = prepareTimestampStr(
		videoDuration,
		item?.Timestamp,
	);

	// item.Extract = {
	//   English: "Some example extract",
	//   Spanish: "Un ejemplo de extracto",
	//   French: "Un exemple d'extrait",
	// };

	const extractEntities = Object.entries(item?.Extract || {});

	return (
		<List.Item>
			<List.Item.Meta
				avatar={
					<span style={{ display: 'block', marginTop: '5px' }}>
						{item?.Emoji}
					</span>
				}
				title={
					<span
						style={{
							color: '#000',
							fontWeight: 500,
							display: 'block',
							marginBottom: '0.5rem',
						}}
					>
						{seconds !== null && (
							<Button
								type="link"
								style={{
									padding: '2px 2px',
									marginRight: '4px',
								}}
								onClick={() => videoSeekToTime(seconds)}
							>
								{preparedTimestampStr}
							</Button>
						)}

						{item?.Sentence}

						{item?.Extract && (
							<Button
								type="text"
								size="small"
								icon={collapsed ? <CaretDownOutlined /> : <CaretUpOutlined />}
								onClick={() => setCollpased((cur) => !cur)}
								style={{ marginLeft: '0.5rem' }}
								aria-label={'Toggle expand/collapse'}
							></Button>
						)}
					</span>
				}
				description={
					collapsed ? null : (
						<span
							style={{
								color: '#000',
								fontStyle: 'italic',
							}}
						>
							{typeof item?.Extract === 'string' ? (
								<span>"{item?.Extract}</span>
							) : (
								<ExtractLocaleItems data={extractEntities} />
							)}
						</span>
					)
				}
			/>
		</List.Item>
	);
}
